import { usePushesStore } from "@/store/pushes";
import { defineStore } from "pinia";
import { ref, watch } from "vue";
export const usePushNotificationStore = defineStore("pushNotification", () => {
  const notifications = ref([]);
  const maxNotifications = 4;
  const pushesStore = usePushesStore();
  const isNotificationsEnabled = ref(
    localStorage.getItem("isNotificationsEnabled") === "true"
  );
  const closedNotificationIds = ref(
    new Set(JSON.parse(localStorage.getItem("closedNotificationIds") || "[]"))
  );

  // Отслеживаем изменения в основном сторе пушей
  watch(
    () => pushesStore.pushes,
    (newPushes) => {
      if (isNotificationsEnabled.value && newPushes) {
        // Проверяем, включены ли уведомления и есть ли данные
        updateNotifications(newPushes);
      }
    },
    { deep: true }
  );

  // Функция для обновления списка уведомлений
  function updateNotifications(pushes) {
    // Добавляем проверку на существование pushes и что это массив
    if (!pushes || !Array.isArray(pushes)) {
      return;
    }

    // Фильтруем пуши, исключая закрытые уведомления
    const availablePushes = pushes.filter(
      (push) => !closedNotificationIds.value.has(push.id)
    );

    // Сортируем новые пуши по времени создания (от новых к старым)
    const sortedNewPushes = [...availablePushes].sort(
      (a, b) =>
        new Date(b.date).getTime() - new Date(a.date).getTime()
    );

    // Берем только самые свежие уведомления
    const freshPushes = sortedNewPushes.slice(0, maxNotifications);

    // Обновляем список отображаемых уведомлений
    notifications.value = freshPushes.map((push) => ({
      ...push,
    }));
  }

  function removeNotification(push) {
    // Добавляем ID уведомления в список закрытых
    closedNotificationIds.value.add(push.id);

    // Сохраняем в localStorage
    localStorage.setItem(
      "closedNotificationIds",
      JSON.stringify([...closedNotificationIds.value])
    );

    // Удаляем из текущих уведомлений
    const index = notifications.value.findIndex((n) => n.id === push.id);
    if (index > -1) {
      notifications.value.splice(index, 1);
    }
  }

  // Функция для включения/выключения уведомлений
  function toggleNotifications() {
    isNotificationsEnabled.value = !isNotificationsEnabled.value;
    localStorage.setItem(
      "isNotificationsEnabled",
      isNotificationsEnabled.value.toString()
    );

    if (!isNotificationsEnabled.value) {
      // Если уведомления выключены, очищаем массив
      notifications.value = [];
    } else {
      // Если уведомления включены, сразу заполняем массив текущими данными
      // Добавляем проверку на существование данных
      const currentPushes = pushesStore.filteredItems || pushesStore.pushes || [];
      updateNotifications(currentPushes);
    }
  }

  // Функция для проверки состояния уведомлений
  function getNotificationsState() {
    return isNotificationsEnabled.value;
  }

  function clearClosedNotifications() {
    closedNotificationIds.value.clear();
    localStorage.removeItem("closedNotificationIds");
  }

  return {
    notifications,
    removeNotification,
    toggleNotifications,
    getNotificationsState,
    clearClosedNotifications,
  };
});